import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex'
import ChartLine from '@/components/chart/chart-line'
import { onMounted, ref, watch } from 'vue'
import communityDashboardService from '@/services/community-dashboard.services'
import { useRoute } from 'vue-router'
import { convertDateChartToJapanese } from '@/constants/datepicker'
import { DASHBOARD_STORE } from '@/store/constants'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  props: {
  step: {
    type: Number,
  },
  title: {
    type: String,
  },
  weekly_flag: {
    type: Boolean,
  },
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const labelCharts = ref([])
const dataEmployees = ref([])
const dataAlumnus = ref([])
const loading = ref(true)
const errorCallApi = ref(false)
const store = useStore()

onMounted(() => {
  getDataChart()
})
watch(
  () => props.date?.from,
  () => {
    getDataChart()
  }
)
watch(
  () => props.date?.to,
  () => {
    getDataChart()
  }
)

const getDataChart = async () => {
  try {
    loading.value = true
    const res = await communityDashboardService.getActiveUsers(route?.params?.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
      weekly_flag: props.weekly_flag,
    })
    loading.value = false
    if (res.data?.success) {
      errorCallApi.value = false
      labelCharts.value = convertDateChartToJapanese(res.data.data.labels)
      dataEmployees.value = res.data.data.employees
      dataAlumnus.value = res.data.data.alumnus

      store.dispatch(DASHBOARD_STORE.ACTIONS.SET_LATEST_ANALYTIC_DATE, res.data.data.latest_analytics_date)
    } else {
      errorCallApi.value = true
    }
  } catch (error) {
    loading.value = true
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ChartLine), {
    errorCallApi: errorCallApi.value,
    loading: loading.value,
    step: __props.step,
    labelCharts: labelCharts.value,
    dataChart: { dataAlumnus: dataAlumnus.value, dataEmployees: dataEmployees.value },
    getDataChart: getDataChart,
    title: __props.title,
    date: __props.date
  }, null, 8, ["errorCallApi", "loading", "step", "labelCharts", "dataChart", "title", "date"]))
}
}

})